import { ca } from '@cian/analytics';

import { TNotificationFrequencyValue } from './popup';
import { IJsonQuery } from '../../../json_query';

export function trackSaveButtonClick() {
  ca('event', {
    name: 'oldevent',
    category: 'subscription',
    action: 'Open',
    label: 'From_cat_save',
  });
}

/**
 * Клик на старую кнопку сохранить, при раскрытых новых расширенных фильтрах
 */
export function trackSaveButtonWithAdvancedFilterClick() {
  ca('event', {
    name: 'oldevent',
    category: 'subscription',
    action: 'Open',
    label: 'From_cat_save_filters',
  });
}

export function trackSubscribed(
  notificationFrequency: TNotificationFrequencyValue,
  showPushNotification: boolean,
  isPushCheck: boolean,
  isAdvancedFiltersOpened?: boolean,
) {
  const tackNotificationFrequencyMap = {
    1: 'Hourly',
    2: 'Daily',
    3: 'Weekly',
  };

  // При открытых новых расширенных фильтрах добавляется _fastfilters
  let label = `From_cat_save${isAdvancedFiltersOpened ? '_fastfilters' : ''}/`;

  label += tackNotificationFrequencyMap[notificationFrequency];

  if (showPushNotification) {
    const pushOnOff = isPushCheck ? 'PushOn' : 'PushOff';

    label += `/${pushOnOff}`;
  }

  ca('event', {
    name: 'oldevent',
    category: 'subscription',
    action: 'Send',
    label,
  });
}

export function trackingSubscribeWithFlag() {
  ca('event', {
    name: 'oldevent',
    category: 'subscription',
    action: 'Send',
    label: 'news_From_cat_save',
  });
}

export function trackingSaveFilterSend(searchConditions: IJsonQuery) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'subscription',
    action: 'try_to_send',
    label: 'From_cat_save',
    searchConditions,
  });
}

export function trackingShowSaveOnNarrow() {
  ca('event', {
    name: 'oldevent',
    category: 'Listing',
    action: 'click_saved_search',
    label: 'narrow',
  });
}

export function trackingShowSaveOnWide() {
  ca('event', {
    name: 'oldevent',
    category: 'Listing',
    action: 'click_saved_search',
    label: 'wide',
  });
}

export function trackNewAccountRegistration() {
  ca('event', {
    name: 'oldevent',
    category: 'Registration',
    action: 'subscription',
    label: 'From_cat_save',
  });
}
